define('publicsite/modules/wistiavideo',['jquery', 'libs/swiper.min'], function ($, Swiper) {
    return {
        swiperInstance: null,

        initPlaylistCarousel: function(playlistId) {
            var swiperInstance = new Swiper('#' + playlistId, {
                spaceBetween: 4,
                direction: 'horizontal',
                watchOverflow: true,
                slidesPerView: 'auto',
                navigation: {
                    nextEl: '.ef-wistia-button-next',
                    prevEl: '.ef-wistia-button-prev',
                    disabledClass: 'ef-wistia-button-disabled'
                }
            });

            this.swiperInstance = swiperInstance;
            return this.swiperInstance;
        },

        applySwatchLoadListener: function(swatchId) {
            var _self = this;
            $('#' + swatchId).on('load', _self.handleSwatchLoad);
        },

        handleSwatchLoad: function(event) {
            event.target.parentNode.style.opacity = '1';
        },

        applyThumbnailImage: function (playlistItemImageId, playlistItemId, thumbnailUrl, videoId, wistiaMediaUrlBase, wistiaOEmbedUrlBase) {
            var _self = this;

            var metaData = {
                playlistItemId: playlistItemId,
                swiperInstance: _self.swiperInstance
            };

            // The "swatch" image URL is predictable using video ID, but the quality sucks.
            // We'll start by temporarily showing this.
            $('#' + playlistItemImageId)
                .on("error", _self.handlePlaylistItemError.bind(metaData))
                .attr('src', thumbnailUrl)
                .css('visibility', 'visible');

            // The "thumbnail" URL must be retrieved via API call, but the quality is good.
            // So while the crappy swatch is loading, start fetching this.
            _self.getHighQualityThumbnailUrl(videoId, wistiaMediaUrlBase, wistiaOEmbedUrlBase).then(function (thumbnailUrl) {
                $('#' + playlistItemImageId).attr('src', thumbnailUrl);
            });
        },

        handlePlaylistItemError: function (event) {
            // If the thumbnail image failed to load, assume this video can't load either. Remove from playlist.
            $('#'+ this.playlistItemId).remove();
            this.swiperInstance.update();
        },

        getHighQualityThumbnailUrl: function (videoId, wistiaMediaUrlBase, wistiaOEmbedUrlBase) {
            var videoUrl = wistiaMediaUrlBase + videoId;
            var encodedVideoUrl = encodeURIComponent(videoUrl);
            var oEmbedVideoRequestUrl = wistiaOEmbedUrlBase + encodedVideoUrl;

            return fetch(oEmbedVideoRequestUrl)
                .then(function (response) {
                    return response.json();
                })
                .then(function (data) {
                    return data.thumbnail_url;
                });
        },
    };
}); 
